// UpgradePopup.js
import React from "react";
import { useNavigate } from "react-router-dom";

const UpgradePopup = () => {
  const navigate = useNavigate();

  // Handler for the Upgrade button click
  const handleUpgradeClick = () => {
    // Navigate to the billing page
    navigate("/billing");
  };

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 bg-gradient-to-r from-fuchsia-900 to-fuchsia-700 py-4 text-white shadow-2xl sm:left-72"
    >
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-4 px-4 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
        <div className="text-center sm:text-left">
          <h2 className="mb-1 text-lg font-bold">Upgrade Your Plan</h2>
          <p className="text-sm text-white/90">
            Unlock all the features to get the most out of our platform. Upgrade your plan now!
          </p>
        </div>
        <button
          onClick={handleUpgradeClick}
          className="rounded-md bg-white px-6 py-2 font-semibold text-purple-900 transition-all hover:bg-gray-100"
        >
          Upgrade Now
        </button>
      </div>
    </div>
  );
};

export default UpgradePopup;
